<template>
  <div id="MyHealthArea">
    <template v-if="healthArea">
      <div class="my-health-area-top">
        <GoBackBtn />
        <h2 class="brand-highlight-3 my-health-area-title mt-4 text-left">
          {{ healthArea.title }}
        </h2>
      </div>
      <MyHealthList
        :services="healthArea.service_pages"
        :handleClick="handleHealthItemClick"
        :isAdditionalInfoShown="true"
      />
    </template>
    <ServiceNotFound v-else-if="services && !services.length" />
    <Loader v-else-if="!services" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MyHealthList from "../components/MyHealth/MyHealthList.vue";
import GoBackBtn from "../components/MyHealth/GoBackBtn.vue";
import ServiceNotFound from "../components/TMH/ServiceNotFound.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "MyHealthArea",
  components: {
    MyHealthList,
    GoBackBtn,
    ServiceNotFound,
    Loader
  },
  data() {
    return {
      healthArea: null
    };
  },
  computed: {
    ...mapState(["services"]),
    passedHealthAreaId() {
      return this.$route.params.areaId;
    }
  },
  mounted() {
    this.scrollToTop();
    this.setHealthArea();
  },
  methods: {
    setHealthArea() {
      if (this.services) {
        this.healthArea = this.services.find(service => {
          return service.id === this.passedHealthAreaId;
        });
      }
    },
    handleHealthItemClick(servicePage) {
      this.$store.dispatch("updateServicePage", servicePage);
      this.$store.dispatch("updateHandoverPage", servicePage.handover_page);
      this.$router.push({
        name: "myHealthHandover",
        params: { areaId: this.passedHealthAreaId, serviceId: servicePage.simplyhealth_id }
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    services: "setHealthArea"
  }
};
</script>

<style lang="less">
#MyHealthArea {
  min-height: 100%;
  background-color: #fff;
  padding: 0 24px 40px;
  font-family: "PlusJakartaSansBold";

  .my-health-area-top {
    padding: 24px 0;
  }

  .my-health-area-title {
    font-family: "PlusJakartaSansExtraBold";
    font-size: 2.6rem;
    margin: 0;
  }
}
</style>
